//natives
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

export default (props, value, tableMeta, updateValue) => {
    return (
        <div>
            {value &&
                <div>
                    <Tooltip title={'Apagar item'}>
                        <a
                            onClick={(e)=>{props.inputRef.current.handleOpen(value.id)}}
                            style={{
                                color:'#ff7676',
                                cursor: 'pointer'
                            }}
                        >
                            <DeleteIcon />
                        </a>
                    </Tooltip>
                    <Tooltip title={'Editar item'}>
                        <a
                            href={"/#"+value.link+"-ae/"+value.id}
                            style={{color:'#6b61ff'}}
                        >
                            <EditIcon />
                        </a>
                    </Tooltip>
                </div>
            }
            {value == null &&
                'Não foi possível carregar valores!'
            }
        </div>
    );
};